import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice from "./slices/authSlice";
import branchesSlice from "./slices/branchesSlice";
import ageGroupsSlice from "./slices/ageGroupsSlice";
import groupsSlice from "./slices/groupsSlice";
import studentsSlice from "./slices/studentsSlice";
import packagePlansSlice from "./slices/packagePlansSlice";
import attendanceSlice from "./slices/attendanceSlice";
import packagesSlice from "./slices/packagesSlice";
import trainersSlice from "./slices/trainersSlice";
import reportsSlice from "./slices/reportsSlice";
import financeSlice from "./slices/financeSlice";
import wpConfigSlice from './slices/wpConfigSlice';
import newsSlice from './slices/newsSlice';
import studentParentsSlice from './slices/studentParentsSlice';
import placeSlice from './slices/placeSlice';
import notificationSlice from './slices/notificationSlice';
import achievementsSlice from "./slices/achievementsSlice";
import matchesSlice from "./slices/matchesSlice";
import ownerSlice from "./slices/ownerSlice";
const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["token", "isLogged", "owner", "authorities"], // Tüm auth verilerini sakla
};

const persistedAuthReducer = persistReducer(authPersistConfig, authSlice);

const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    branches: branchesSlice,
    ageGroups: ageGroupsSlice,
    groups: groupsSlice,
    students: studentsSlice,
    packagePlans: packagePlansSlice,
    attendance: attendanceSlice,
    packages: packagesSlice,
    trainers: trainersSlice,
    reports: reportsSlice,
    finance: financeSlice,
    wpConfig: wpConfigSlice,
    news: newsSlice,
    studentParents: studentParentsSlice,
    place: placeSlice,
    notification: notificationSlice,
    achievements: achievementsSlice,
    matches: matchesSlice,
    owner: ownerSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Serileştirilebilirlik kontrolünü kapat
    })
  });

// Persistor oluştur
export const persistor = persistStore(store);

export default store;
